<template>
	<div>
		<action-sidebar
			:title="title"
			:value="true"
			@close-modal="closeModal"
		>
			<app-form :app-id="id" :code-project="codeProject" />
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import appForm from '@/components/apps/app-form';

function closeModal() {
	this.goTo('page-app');
}

function title() {
	const app = 'Aplicación';
	return this.id ? `Editar ${app}` : `Crear ${app}`;
}

export default {
	name: 'page-app-new',
	components: {
		actionSidebar,
		appForm,
	},
	computed: {
		title,
	},
	methods: {
		closeModal,
	},
	props: {
		codeProject: {
			type: String,
			required: true,
		},
		id: {
			type: [Number, String],
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/apps/page-app-new.vue